import editors from "./editors";
import selectorgrids from "./SelectorGrids";
import selectorimages from "./SelectorImages";
import boxes from "./Boxes";
import menu from "./menu";
import pace from "./pace";

const actionTypes = {
    ...editors,
    ...selectorgrids,
    ...selectorimages,
    ...boxes,
    SHOW_MODAL: "SHOW_MODAL",
    CLOSE_MODAL: "CLOSE_MODAL",
    TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
    SET_USER: "SET_USER",
    SET_TILL: "SET_TILL",
    SET_CONTENT: "SET_CONTENT",
    ...menu,
    ...pace,
    NULL: null,
    REDUX_STORE_CHANGED: "@@redux/STORE_CHANGED"
};

export default actionTypes;